import script from "./settings.vue?vue&type=script&setup=true&lang=js"
export * from "./settings.vue?vue&type=script&setup=true&lang=js"

import "./settings.vue?vue&type=style&index=0&id=4d95e8ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d95e8ca"]])

export default __exports__